import { RefObject, useEffect, useState } from "react";

/**
 * 스크롤 컨테이너가 맨 위에서 조금이라도 내려갔는지를 알려주는 훅.
 *
 * useScrolledToBottom과 같이 window가 아니라 임의의 overflow 요소를 대상으로 한다.
 * 내용 높이가 줄어 scrollTop이 바뀌는 경우에도 브라우저가 scroll 이벤트를 내므로
 * 스크롤 이벤트만 구독한다.
 */
export default function useScrolledFromTop(
  ref: RefObject<HTMLElement>
): boolean {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const update = () => setIsScrolled(el.scrollTop > 0);

    update();
    el.addEventListener("scroll", update, { passive: true });
    return () => el.removeEventListener("scroll", update);
  }, [ref]);

  return isScrolled;
}
